import { FormSpecification } from "../../interface/type/form-specification.type";
import { DateToStringConverter } from "../converter/date-to-string.converter";
import { IdentityConverter } from "../converter/identity.converter";
import { HolidayDateValidator } from "../validator/holiday-date.validator";
import { HolidayDescriptionValidator } from "../validator/holiday-description.validator";
import { HolidayEditCrossValidator } from "../validator/holiday-edit.cross.validator";
import { HolidayTypeValidator } from "../validator/holiday-type.validator";

	/**
	 * @description
	 *  Formulario para edición de días del calendario no-laborables.
	 */

export const HolidayEditForm: FormSpecification = {

	"holidayEditForm": {
		crossValidator: true,
		default: undefined,
		validatorFactory: HolidayEditCrossValidator,
		converter: IdentityConverter,
		errors: [
			{
				type: "overlap",
				message: "El día especificado no puede ser \"no-laborable\" porque existen zonas activas en esa fecha (hay {{overlap.count}}): {{overlap.zones}}."
			}
		]
	},
	"description": {
		crossValidator: false,
		default: undefined,
		validatorFactory: HolidayDescriptionValidator,
		converter: IdentityConverter,
		errors: [
			{
				type: "minlength",
				message: "La descripción debe tener al menos {{minlength.requiredLength}} caracteres (tiene {{minlength.actualLength}})."
			},
			{
				type: "maxlength",
				message: "La descripción no debe tener más de {{maxlength.requiredLength}} caracteres (tiene {{maxlength.actualLength}})."
			},
			{ type: "required", message: "Debe especificar una descripción para el día seleccionado." }
		]
	},
	"date": {
		crossValidator: false,
		default: undefined,
		validatorFactory: HolidayDateValidator,
		converter: DateToStringConverter,
		errors: [
			{ type: "matDatepickerParse", message: "El formato de la fecha es inválido, debe ser \"dd/mm/aaaa\"." },
			{ type: "required", message: "Debe especificar una fecha." }
		]
	},
	"type": {
		crossValidator: false,
		default: undefined,
		validatorFactory: HolidayTypeValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar un tipo para el día seleccionado." }
		]
	}
};
